export default "__VITE_PUBLIC_ASSET__24c42d28__"